import type API from "@/Api/API";
import type {
	GlobalStats,
	PlaySession,
	PlaytimeByWay,
	RecentActivity,
	SceneUsage,
	SessionOverTime,
} from "@/types/scene";

export default class Statistics {
	api: API;

	constructor(api: API) {
		this.api = api;
	}

	async getGlobalStats(
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<GlobalStats> {
		const params: Record<string, unknown> = {};
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/global", { params })
			.then((res) => res.data);
	}

	async getSessionsOverTime(
		days: number = 30,
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<SessionOverTime[]> {
		const params: Record<string, unknown> = { days };
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/sessions-over-time", { params })
			.then((res) => res.data);
	}

	async getPlaytimeByWay(
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<PlaytimeByWay[]> {
		const params: Record<string, unknown> = {};
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/playtime-by-way", { params })
			.then((res) => res.data);
	}

	async getSceneUsageStats(
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<SceneUsage[]> {
		const params: Record<string, unknown> = {};
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/scene-usage", { params })
			.then((res) => res.data);
	}

	async getRecentActivity(
		limit: number = 20,
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<RecentActivity[]> {
		const params: Record<string, unknown> = { limit };
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/recent-activity", { params })
			.then((res) => res.data);
	}

	async getTotalSessionCount(
		targetUuid?: string | null,
		showGlobalStats?: boolean
	): Promise<number> {
		const params: Record<string, unknown> = {};
		if (showGlobalStats) {
			params.global = true;
		} else if (targetUuid) {
			params.targetUuid = targetUuid;
		}
		return this.api
			.processRequest("GET", "/statistics/session-count", { params })
			.then((res) => res.data);
	}

	async getRecentSessions(
		userUuid: string,
		limit: number = 10
	): Promise<PlaySession[]> {
		const params: Record<string, unknown> = { limit };
		return this.api
			.processRequest("GET", `/statistics/${userUuid}/sessions`, {
				params,
			})
			.then((res) => res.data);
	}
}
